
import { Link } from 'react-router-dom';

export default function IntroSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block text-sm font-semibold tracking-widest text-secondary uppercase mb-4">Trusted by Dallas Physicians & Executives</span>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-primary mb-6 leading-tight">
              Your Trusted <strong>Private Health Insurance</strong> Partner in Dallas
            </h2>
            <p className="text-base text-gray-700 mb-5 leading-relaxed">
              At Dallas Health Insurance Experts, we specialize in serving <strong>Highland Park</strong>, <strong>University Park</strong>, <strong>Preston Hollow</strong>, and <strong>Park Cities</strong> families with premium private health insurance solutions. Our independent agency partners with 20+ top-rated carriers to deliver unbiased, concierge-level guidance.
            </p>
            <p className="text-base text-gray-700 mb-8 leading-relaxed">
              Whether you are a physician seeking comprehensive coverage, an executive protecting your family, or a business owner insuring your team — we compare plans, explain options clearly, and handle enrollment at no cost to you.
            </p>

            {/* Trust Badges */}
            <div className="flex flex-wrap gap-4 mb-10">
              <div className="flex items-center gap-2 bg-emerald-50 px-4 py-2 rounded-full">
                <i className="ri-shield-check-line text-emerald-600"></i>
                <span className="text-sm font-medium text-emerald-800">Licensed & Certified</span>
              </div>
              <div className="flex items-center gap-2 bg-sky-50 px-4 py-2 rounded-full">
                <i className="ri-award-line text-sky-600"></i>
                <span className="text-sm font-medium text-sky-800">A+ BBB Rating</span>
              </div>
              <div className="flex items-center gap-2 bg-amber-50 px-4 py-2 rounded-full">
                <i className="ri-star-line text-amber-600"></i>
                <span className="text-sm font-medium text-amber-800">4.9 Star Reviews</span>
              </div>
            </div>

            <Link
              to="/contact"
              className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3.5 bg-primary hover:bg-primary/90 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
            >
              Get Your Free Consultation
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Right Image Grid */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="w-full h-56 rounded-lg overflow-hidden shadow-xl">
                  <img
                    src="https://public.readdy.ai/ai/img_res/fded3cd16af617fcfa0a25a5fd7dfda6.jpg"
                    alt="Dallas physician consulting with Highland Park family about private health insurance coverage"
                    title="Premium health insurance consultation Dallas"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-full h-40 rounded-lg overflow-hidden shadow-xl">
                  <img
                    src="https://readdy.ai/api/search-image?query=happy%20wealthy%20family%20with%20children%20smiling%20together%20in%20beautiful%20upscale%20home%20living%20room%2C%20warm%20natural%20light%2C%20elegant%20casual%20clothing%2C%20affluent%20lifestyle%2C%20joyful%20family%20portrait%2C%20soft%20warm%20tones&width=500&height=350&seq=intro-family-happy-2&orientation=landscape"
                    alt="Affluent Dallas family protected by premium health insurance"
                    title="Family health insurance Highland Park Dallas"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="w-full h-40 rounded-lg overflow-hidden shadow-xl">
                  <img
                    src="https://readdy.ai/api/search-image?query=successful%20business%20executive%20woman%20in%20elegant%20blazer%20smiling%20confidently%20in%20modern%20corner%20office%20with%20city%20skyline%20view%2C%20professional%20portrait%2C%20warm%20golden%20lighting%2C%20leadership%20presence&width=500&height=350&seq=intro-exec-woman-3&orientation=landscape"
                    alt="Dallas executive with premium private health insurance coverage"
                    title="Executive health insurance plans Dallas TX"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-full h-56 rounded-lg overflow-hidden shadow-xl">
                  <img
                    src="https://readdy.ai/api/search-image?query=team%20of%20diverse%20medical%20professionals%20doctors%20and%20nurses%20standing%20together%20smiling%20in%20modern%20hospital%20hallway%2C%20white%20coats%20stethoscopes%2C%20confident%20trustworthy%2C%20premium%20healthcare%20facility%2C%20bright%20clean%20environment&width=500&height=450&seq=intro-medical-team-4&orientation=portrait"
                    alt="Top Dallas medical professionals in premium provider network"
                    title="Dallas health insurance provider network physicians"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>

            {/* Floating Stats Card */}
            <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 bg-white rounded-lg shadow-2xl px-8 py-5 flex gap-8 border border-gray-100">
              <div className="text-center">
                <div className="text-2xl font-bold text-secondary">2,500+</div>
                <div className="text-xs text-gray-500">Clients Served</div>
              </div>
              <div className="w-px bg-gray-200"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-secondary">15+</div>
                <div className="text-xs text-gray-500">Years in Dallas</div>
              </div>
              <div className="w-px bg-gray-200"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-secondary">$8M+</div>
                <div className="text-xs text-gray-500">Saved for Clients</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
